import { chainography, } from "../../package.json"


export const getExplorerLink = ( txHash: string, chainId: number, ): string => {
  const { hostname, } = globalThis.location;
  if(hostname.endsWith(".bracket.fi") && !hostname.startsWith("staging")) {
    return `https://etherscan.io/tx/${txHash}`;
  }
  return `${chainography[`CHAIN_${chainId}_EXPLORER`]}/tx/mainnet/${txHash}`;
}